import React from "react";
import {Card, Grid, useTheme} from "@leap4/frontend"
import ValueWithPercent from "../../../../../shared/ValueWithPercent"
import KeyValueContainer from "../../../../../shared/KeyValueContainer";
import MetricValue from "../../../../../shared/MetricValue";
import {Link} from "react-router-dom";
import { IPublisherDiscOverview} from "../../../interfaces/DataPointDtoMainPage.interface";
import {urlService} from "../../../../../routing/urlsService";
import {EntitiesProperties} from "../../../../../../utils/enums";

export interface IPublisherDataPointProps {
    dataPointOverview: IPublisherDiscOverview
}


export const PublisherDataPointCard =(props: IPublisherDataPointProps): JSX.Element => {
    const theme = useTheme()
    const {dataPointOverview} = props
    const {dataPoint, discrepancy, latestDate} = dataPointOverview

    return <Card
        {
            ...{
                         header: {
                             title: dataPoint.name.toUpperCase(),
                             subtitle: (dataPoint.adServer as any).name.toString()
                         },
                style: {borderRadius: "16px", border: "1px solid #dedede ",  boxShadow: 'none'},
            actionsArea: {
                             children:
                                 <Link style={{color: theme.palette.text.primary}}
                                       to={`${urlService.publisherDataPoint(dataPoint._id.toString(), true)}`}><Grid
                                     alignContent="space-between" alignItems="center" container>

                                     <Grid item xs={12}>

                                         <h2 style={{fontStyle: "oblique"}}> ADSERVERS TOTALS</h2>

                                         <KeyValueContainer
                                             title={"REVENUE"}
                                             value={
                                                 <MetricValue
                                                     style={{fontSize: "x-large"}}
                                                     prop={EntitiesProperties.NUMERIC.ALL.REVENUE}
                                                     value={discrepancy.adServerRevenue}
                                                 />
                                             }
                                         />

                                         <KeyValueContainer
                                             title={"IMPRESSIONS"}
                                             value={
                                                 <MetricValue
                                                     style={{fontSize: "x-large"}}
                                                     prop={EntitiesProperties.NUMERIC.ALL.IMPRESSIONS}
                                                     value={discrepancy.adServerImpressions}
                                                 />
                                             }
                                         />

                                         <h2 style={{fontStyle: "oblique"}}> DISCREPANCY</h2>
                                         <KeyValueContainer
                                             title={"REVENUE"}
                                             value={
                                                 <ValueWithPercent
                                                     style={{fontSize: "x-large"}}
                                                     value={discrepancy.revenueDiscPercent}
                                                 />
                                             }
                                         />
                                         <KeyValueContainer
                                             title={"IMPRESSIONS"}
                                             value={
                                                 <ValueWithPercent
                                                     style={{fontSize: "x-large"}}
                                                     value={discrepancy.impressionsDiscPercent}
                                                 />
                                             }
                                         />


                                         <h2 style={{fontStyle: "oblique"}}> PUBLISHER TOTALS</h2>
                                         <KeyValueContainer
                                             title={"REVENUE"}
                                             value={
                                                 <MetricValue
                                                     style={{fontSize: "x-large"}}
                                                     prop={EntitiesProperties.NUMERIC.ALL.REVENUE}
                                                     value={discrepancy.publisherRevenue}
                                                 />
                                             }
                                         />

                                         <KeyValueContainer
                                             title={"IMPRESSIONS"}
                                             value={
                                                 <MetricValue
                                                     style={{fontSize: "x-large"}}
                                                     prop={EntitiesProperties.NUMERIC.ALL.IMPRESSIONS}
                                                     value={discrepancy.publisherImpressions}
                                                 />
                                             }
                                         />


                                     </Grid>
                                     <Grid item xs={12}>
                                         <span> <b> last metric time </b> </span>
                                         <span> {new Date(latestDate).toUTCString()}</span>
                                     </Grid>
                                 </Grid>
                                 </Link>
                         }
                     }} />
}


